import createClient from 'openapi-fetch'
import { fetchAuthSession } from 'aws-amplify/auth'
import type { paths } from './auto-gen-types'
import { auth_listener } from './auth-listener'
import { Capacitor } from '@capacitor/core'

export const trace_id_log: {request_id: string, timestamp: number}[] = [
  /* 表示確認用ダミーデータ
  {
    request_id: 'test',
    timestamp: Date.now()
  },
  {
    request_id: 'test2',
    timestamp: Date.now()
  },
  {
    request_id: 'test3',
    timestamp: Date.now()
  },
  {
    request_id: 'test4',
    timestamp: Date.now()
  },
  */
]

// Create OpenAPI client instance
export const client = createClient<paths>({
  baseUrl: import.meta.env.VITE_ENDPOINT,
})

// Add authentication middleware
client.use({
  async onRequest ({ request }) {
    // Wait for authentication to complete
    if (auth_listener.state === 'configuring') {
      const cancelListen = await new Promise<() => void>(resolve => {
        auth_listener.listen((state, cancel) => {
          if (state !== 'configuring') {
            resolve(cancel)
            // Don't remove listener here as it would prevent await from finishing
          }
        })
      })
      cancelListen()
    }
    const session = await fetchAuthSession()
    // Token can be cached or fresh
    const access_token = session.tokens?.accessToken.toString()
    if (access_token) request.headers.set('Authorization', `Bearer ${access_token}`)
    return request
  },

  async onResponse ({ response }) {
    const request_id = response.headers.get('X-Request-Id')
    if (request_id) {
      trace_id_log.push({request_id, timestamp: Date.now()})
      // Keep only the last 3 entries
      if (trace_id_log.length > 3) trace_id_log.shift()
    }

    // CapacitorHttpを利用する際に必要になる処理
    if (Capacitor.isNativePlatform()) {
      // CapacitorHttp PluginではContent-Lengthが0になるので、1にする
      // openapi-fetchはContent-Length == 0 だとdataがundefinedになる
      // bytes()を呼ぶと、response.bodyが空になってしまうので、clone()してbytes()を呼ぶ
      // 本当はResponse.bytes()を使いたいが、古いSafariでサポートされていないためarrayBuffer()を使用
      // const content_length = (await response.clone().bytes()).length
      const content_length = (await response.clone().arrayBuffer()).byteLength
      // response.headers.set('Content-Length', '1') はだめ
      // CapacitorHttpのheaderは書き換えられない
      return new Response(response.body, {
        status: response.status,
        statusText: response.statusText,
        headers: new Headers({
          ...response.headers,
          'Content-Length': String(content_length)
        })
      })
    }
    return response
  }
})